import { useExpenseByArticlesReport } from './useExpenseByArticlesReport';

export { useExpenseByArticlesReport };
